import { useInbound } from './useInbound';
import { Link, Table } from '../../../components';
import { getCurrentOrg } from '../../../api';
import { buildAgentsPath } from '../../../app/Routes/orgRouteUtils';

export const InboundTab = () => {
  const { loading, data, agentsMap, sipTrunkName } = useInbound();
  const orgId = getCurrentOrg();

  return (
    <Table
      loading={loading}
      data={data}
      config={{
        columns: [
          {
            header: 'Agent Title',
            getValue: ({ agentId }) => agentsMap.get(agentId) || agentId,
          },
          {
            header: 'SIP Trunk name',
            getValue: () => sipTrunkName,
          },
          {
            header: 'Phone Numbers',
            getValue: ({ phoneNumbers }) =>
              (phoneNumbers || [])
                .map(
                  ({ phoneNumber, id }) =>
                    !!phoneNumber && (
                      <span key={id} className="mr-sm">
                        {phoneNumber}
                      </span>
                    )
                )
                .filter(Boolean),
          },
          {
            header: 'Actions',
            getValue: ({ agentId }) =>
              !!agentId && (
                <Link
                  newTab
                  withIcon
                  withDecoration
                  className="font-semibold"
                  url={`${buildAgentsPath(orgId, agentId)}?tab_name=telephony`}
                >
                  Edit
                </Link>
              ),
          },
        ],
      }}
    />
  );
};

export default InboundTab;
